import { HeaderCarouselPropsApi } from '../..'
import { FilmListPropsApi } from '../../components/filmList'
import { PageResponse } from '../../services/models'

export class HomePageResponse extends PageResponse {
    components = {
        HeaderCarousel: [new HeaderCarouselPropsApi()],
        FilmList: new FilmListPropsApi(),
    }
}
